import React, { useState, useEffect } from "react";
import answeringBot from "../../../assets/images/landing/answeringRobot.mp4"
export default function ChatButton() {
    const [showTooltip, setShowTooltip] = useState(false);
    const [tooltipClosed, setTooltipClosed] = useState(false);


    useEffect(() => {
        if (!tooltipClosed) {
            const timer = setTimeout(() => {
                setShowTooltip(true);
            }, 1000);
            return () => clearTimeout(timer);
        }
    }, [tooltipClosed]);



    return (
        <>

            <style>
                {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateX(5px); }
            to { opacity: 1; transform: translateX(0); }
          }
          .animate-fadeIn {
            animation: fadeIn 0.3s ease-out;
          }
          .tooltip-box {
            background: white;
            border: 1px solid #e5e7eb;
            box-shadow: 0 4px 12px rgba(0,0,0,0.1);
            border-radius: 1rem;
            padding: 0.75rem 1rem;
            font-size: 0.875rem;
            font-weight: 500;
            max-width: 14rem;
            position: absolute;
            right: 3rem; /* فاصله از دکمه */
            bottom: 0;
            animation: fadeIn 0.3s ease-out;
          }
          .tooltip-box p {
            margin: 0;
            text-align: right;
            padding-right: 0.5rem;
          }
          .tooltip-close {
            position: absolute;
            top: 0.25rem;
            left: 0.5rem;
            font-size: 1rem;
            font-weight: bold;
            color: #9ca3af;
            cursor: pointer;
          }
          .tooltip-close:hover {
            color: #4b5563;
          }
        `}
            </style>

            <div className="fixed bottom-6 right-6 flex items-center gap-2 z-[1000]">

                {showTooltip && (
                    <div className="tooltip-box w-[200px] mr-9 mb-4">
                        <button
                            className="tooltip-close"
                            onClick={() => {
                                setShowTooltip(false);
                                setTooltipClosed(true);
                            }}
                        >
                            ×
                        </button>
                        <p className="text-center">
                            سؤالتو از <span className="text-yellow-500 font-semibold">رایابات</span> بپرس.
                        </p>
                    </div>
                )}

                <a href="/rayabot" target="_blank" rel="noopener noreferrer">
                    <button

                        className="bg-yellow-400 hover:bg-yellow-500 rounded-full w-20 h-20 text-3xl shadow-md flex items-center justify-center transition-all duration-300"
                    >
                        <video
                            src={answeringBot} 
                            autoPlay
                            muted
                            loop
                            playsInline
                            className="w-full h-full object-cover rounded-full"
                        />
                    </button>
                </a>
            </div>
        </>
    );
}
